import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Fab,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchApplications } from "../../actions";
import { Content } from "../layout";
import { pageLimit as limit } from "../../config/keys";
// import Pagination from "../common/Pagination";
import { fabStyle } from "../common/style";

const ApplicationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector(
    (state) => state.application.applications
  );
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) {
      dispatch(fetchApplications({ page, limit }));
    }
  }, [dispatch, page, user]);

  const navigateToApplicationDetail = (id) => {
    navigate(`/applications/${id}/update`, { state: { id } });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderApplications = () =>
    rows.map((application) => (
      <TableRow
        key={application.id}
        onClick={() => navigateToApplicationDetail(application.id)}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>{application.id}</TableCell>
        <TableCell>{application.description}</TableCell>
        <TableCell>{application.name}</TableCell>
        {/* <TableCell>{application.Organization.displayName}</TableCell> */}
        <TableCell>
          {new Date(application.createdAt).toLocaleString()}
        </TableCell>
      </TableRow>
    ));

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            협력사
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="application-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>이름</TableCell>
                  <TableCell>구분값</TableCell>
                  {/* <TableCell>건설사</TableCell> */}
                  <TableCell>등록일시</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderApplications()}</TableBody>
            </Table>
          </TableContainer>
          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
      <Fab
        sx={fabStyle}
        aria-label="add"
        color="primary"
        component={Link}
        to="/applications/new"
      >
        <AddIcon />
      </Fab>
    </Content>
  );
};

export default ApplicationList;
